export default {
  'notice': '@:terms.notice',
  'message': {
    'empty': ['공지사항이 없습니다.'],
  }
}